module.exports = "https://d1tntvpcrzvon2.cloudfront.net/vwassets/new2/_next/static/images/pdp_paperRecycled-24530fb3641be33215edbb1142b7d672.jpg";